import React from 'react';
import NumericInput from "../input/NumericInput";
import SelectDropdown from "../input/SelectDropdown";
import { Frequency } from "../enums/Frequency";
import HorizontalRule from "./HorizontalRule";
import { TravelFrequency } from "../enums/TravelFrequency";

export type OccupationRequirementsProps = {
    label?: string,
    idPrefix: string,
    required: boolean,
}

const OccupationRequirements = (props: OccupationRequirementsProps) => {
    const frequencyOptions = Object.keys(Frequency).map(p => ({
        id: p.replace(/_/g, '-').toLowerCase(),
        text: (Frequency as any)[p]
    }))
    const travelOptions = Object.keys(TravelFrequency).map(p => ({
        id: p.replace(/_/g, '-').toLowerCase(),
        text: (TravelFrequency as any)[p]
    }))

    const idPrefix = props.idPrefix;
    const required = props.required;
    return <div>
        {props.label && <>
            <HorizontalRule/>
            <label>{props.label}</label>
        </>}
        <SelectDropdown id={`${idPrefix}-sitting-frequency`} label="Sit" required={required} options={frequencyOptions}/>
        <SelectDropdown id={`${idPrefix}-standing-frequency`} label="Stand" required={required} options={frequencyOptions}/>
        <SelectDropdown id={`${idPrefix}-walking-frequency`} label="Walk" required={required} options={frequencyOptions}/>
        <SelectDropdown id={`${idPrefix}-keyboarding-frequency`} label="Keyboarding" required={required} options={frequencyOptions}/>
        <SelectDropdown id={`${idPrefix}-fine-manipulation-frequency`} label="Fine manipulation" required={required} options={frequencyOptions}/>
        <SelectDropdown id={`${idPrefix}-travel-frequency`} label="Travel" required={required} options={travelOptions}/>
        <NumericInput id={`${idPrefix}-lifting-continuously-pounds`} label="Lift continuously (pounds)" required={required} maxLength={4}/>
        <NumericInput id={`${idPrefix}-lifting-frequently-pounds`} label="Lift frequently (pounds)" required={required} maxLength={4}/>
        <NumericInput id={`${idPrefix}-lifting-occasionally-pounds`} label="Lift occasionally (pounds)" required={required} maxLength={4}/>
    </div>
};

export default OccupationRequirements;
